import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import funcoesGerais from '../../funcoes/funcoesGerais';
import { ClienteConsultaCreditoVoucher } from '../../interfaces/cliente';
import { CreditoVoucher } from '../../interfaces/creditoVoucher';
import { CreditoVoucherHistorico } from '../../interfaces/creditoVoucherHistorico';
import { CreditoVoucherHistoricoConsulta } from '../../interfaces/creditoVoucherHistoricoConsulta';
import { UsuarioService } from '../../services/usuario.service';
import { AdicionarCreditoVoucherDialog } from '../dialogs/adicionar-credito-voucher-dialog/adicionar-credito-voucher-dialog';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-adicionar-credito',
  templateUrl: './adicionar-credito.component.html',
  styleUrls: ['./adicionar-credito.component.scss', '../../styles/estilo.padrao.scss']
})
export class AdicionarCreditoComponent implements OnInit {

  uid;
  bConsulta: boolean = false;
  displayedColumns: string[] = ['Nome', 'CPFCNPJ', 'Cidade', 'Estado', 'Status', 'DataUltimoVoucherCreditado', 'Voucher', 'Historico', 'AdicionarCreditoVoucher'];
  clientesSource;

  historicoCreditoVoucher: CreditoVoucherHistoricoConsulta[];

  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
  ) {
    this.uid = localStorage.getItem('uid');

    this.spinner.show('adicionar-credito');
  }

  ngOnInit(): void {
    this.usuarioService.getClientes().pipe(take(1)).subscribe(snap => {
      this.clientesSource = [];

      if (snap.length > 0) {
        let auxClientes: any[] = [];
        var dados: ClienteConsultaCreditoVoucher;

        snap.forEach((item: any, index) => {
          dados = item.payload.val() as ClienteConsultaCreditoVoucher;
          dados.ID = item.key;
          dados.CPFCNPJ = item.payload.val().CPF ? item.payload.val().CPF : item.payload.val().CNPJ;
          dados.StatusString = dados.Status ? 'Ativo' : 'Desativado';
          auxClientes.push(dados);
        });

        this.finalizarBuscaSaldoVoucher(auxClientes);
      } else {
        this.toastr.error("Não foi possível localizar clientes!", 'Erro');
        setTimeout(() => this.spinner.hide('adicionar-credito'), 300);
      }
    });
  }

  async retornaVoucherCliente(idCliente): Promise<CreditoVoucher> {
    return new Promise(resolve => {
      this.usuarioService.getCreditoVoucherCliente(idCliente).pipe(take(1)).subscribe(snap => {
        resolve(snap as CreditoVoucher);
      });
    });
  }

  finalizarBuscaSaldoVoucher(clientes: ClienteConsultaCreditoVoucher[]) {
    let auxClientes: ClienteConsultaCreditoVoucher[] = new Array();
    Promise.all(clientes.map(async (cliente: ClienteConsultaCreditoVoucher) => {
      const dadosVoucher = await this.retornaVoucherCliente(cliente.ID);
      if (dadosVoucher) {
        cliente.TotalVoucher = dadosVoucher.TotalVoucher;
        cliente.DataUltimoVoucherCreditado = funcoesGerais.tratarData(dadosVoucher.TimestampUltimoCreditoVoucher);
        cliente.ExisteVoucherBD = true;
      } else {
        cliente.TotalVoucher = 0;
        cliente.DataUltimoVoucherCreditado = '-';
        cliente.ExisteVoucherBD = false;
      }

      auxClientes.push(cliente);

    })).then((resp => {
      this.clientesSource = new MatTableDataSource(auxClientes);
      this.clientesSource.paginator = this.paginator;

      setTimeout(() => {
        this.clientesSource.paginator = this.paginator;
      });
      this.bConsulta = true;

      setTimeout(() => {
        this.spinner.hide('adicionar-credito');
      }, 100);
    })).catch(error => this.alertarErro())
  }

  adicionarCredito(cliente: ClienteConsultaCreditoVoucher) {
    const dialogRef = this.dialog.open(AdicionarCreditoVoucherDialog, {
      data: { cliente },
    });
  }

  historicoCliente(cliente: ClienteConsultaCreditoVoucher) {
    this.spinner.show('adicionar-credito');

    this.usuarioService.getHistoricoCreditoVoucher(cliente.ID).pipe(take(1)).subscribe(snap => {
      if (snap.length > 0) {

        let dados: CreditoVoucherHistorico;
        let auxHistoricoConsulta: CreditoVoucherHistoricoConsulta;
        this.historicoCreditoVoucher = new Array();
        snap.forEach((item, index) => {
          dados = item.payload.val() as CreditoVoucherHistorico;
          auxHistoricoConsulta = dados as CreditoVoucherHistoricoConsulta;
          auxHistoricoConsulta.Data = funcoesGerais.tratarDataHora(dados.Timestamp);

          this.historicoCreditoVoucher.push(auxHistoricoConsulta);
        });

        this.imprimirRelatorio(cliente);
      } else
        this.finalizarRelatorio(false);
    });
  }

  finalizarRelatorio(b: boolean) {

    setTimeout(() => {
      if (b)
        this.toastr.success("Histórico gerado com sucesso!", 'Status');
      else
        this.toastr.warning("Não há histórico para este cliente!", 'Erro');


      this.spinner.hide('adicionar-credito');
    }, 500);
  }

  imprimirRelatorio(cliente: ClienteConsultaCreditoVoucher) {
    let doc = new jsPDF('l', 'mm', [297, 210]);
    let corpo: any = [];

    this.historicoCreditoVoucher.forEach(dado => {
      var aux = [dado.PedidoReferencia, dado.Descricao, dado.Tipo, dado.Data, 'R$ ' + dado.ValorVoucher.toFixed(2).replace('.', ',')];
      corpo.push(aux);
    });

    autoTable(doc, {
      head: [["Pedido", "Descricao", "Tipo", "Data e hora", "Valor"]],
      theme: 'grid',
      body: corpo,
      didDrawPage: function (data) {
        // Header
        doc.setFontSize(16)
        doc.setTextColor('#525252')
        doc.text(`${cliente.Nome} - ${cliente.CPFCNPJ} - ${cliente.Cidade}/${cliente.UF}`, 5, 22)
      },
      margin: { top: 28, right: 5, bottom: 10, left: 5 },
      showHead: 'firstPage',
      showFoot: 'lastPage',
      foot: [["", "", "", "", `Saldo: ${cliente.TotalVoucher.toFixed(2).replace('.', ',')}`]]
    });
    doc.save(`Relatório_credito_voucher_cliente_${cliente.Nome}.pdf`);

    this.usuarioService.setLog(`Exportou relatório credito voucher. Data:  ${this.usuarioService.tratarData(new Date().getTime())} Cliente: ${cliente.ID}`, null, this.uid);

    this.finalizarRelatorio(true);
  }

  alertarErro() {
    this.toastr.error("Não foi possível recuperar os dados!", 'Erro');
    setTimeout(() => this.spinner.hide('adicionar-credito'), 300);
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.clientesSource.filter = filterValue.trim().toLowerCase();

    if (this.clientesSource.paginator) {
      this.clientesSource.paginator.firstPage();
    }
  }
}
